export function calendarLink(storeId, day) {
  const query = new URLSearchParams();
  if (storeId) query.set('store', storeId);
  if (day) query.set('date', day);
  return '/crm/calendar' + (query.toString() ? '?' + query.toString() : '');
}

export function calendarTarget(search) {
  const query = new URLSearchParams(search);
  const rawDay = query.get('date') || '';
  const date = /^20\d{2}-\d{2}-\d{2}$/.test(rawDay) ? new Date(rawDay + 'T12:00:00Z') : null;
  const day = date && !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === rawDay ? rawDay : '';
  return { storeId: query.get('store') || '', day };
}
